<script setup lang="ts">
import { computed, inject, onBeforeUnmount } from 'vue';
import { tryOnBeforeMount } from '@vueuse/core';
import SharedShareLayout from '@h5-monorepo/shared/components/ShareLayout.vue';
import { isInDocoiApp, isMiniProgram } from '@h5-monorepo/shared/utils/app';
import { useDownloadApp } from '@h5-monorepo/shared/composables/useDownloadApp';
import { getDevice, isWeixin } from '@h5-monorepo/shared/utils/device';
import { provideAppShareLayout, type OpenAppHandler } from '@/composables/useAppShareLayout';

const { downloadApp, showDownloadMask } = useDownloadApp();

const openAppParams = computed(() => {
  return {
    type: 5,
    url: `${window.location.href}`,
    h5Type: 4
  };
});

const defaultOpenApp: OpenAppHandler = () => {
  if (isInDocoiApp() || isMiniProgram) return false;
  const params = { ...openAppParams.value };
  downloadApp(params);
  return true;
};

// 初始化分享布局上下文，接收业务页面通过 useAppShareLayout 注册的配置。
const { shareLayoutProps } = provideAppShareLayout(defaultOpenApp);

const documentHeight = () => {
  const doc = document.documentElement;
  doc.style.setProperty('--doc-height', `${window.innerHeight}px`);
};

tryOnBeforeMount(() => {
  window.addEventListener('resize', documentHeight);
  documentHeight();
});

const setFontSize = inject<(value: number) => void>('setPageScale');

const initPage = () => {
  if (isWeixin) {
    showDownloadMask(false);
  }
  if (['Windows pc', 'Linux pc', 'Mac'].includes(getDevice())) {
    setFontSize?.(1.36); // 510px单位桌面端显示
  } else {
    setFontSize?.(3);
  }
};
initPage();

onBeforeUnmount(() => {
  window.removeEventListener('resize', documentHeight);
});
</script>

<template>
  <div class="page">
    <SharedShareLayout v-bind="shareLayoutProps">
      <slot />
    </SharedShareLayout>
  </div>
</template>

<style lang="scss" scoped>
.page {
  @apply mx-auto of-hidden flex flex-col flex-1 min-h-0 relative;
  width: 10rem;
  height: var(--doc-height);
}
</style>
